import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Routes } from '@angular/router';
import { UserService, SeedDataService, ProfileDataService} from '../../Services/index';
import {TreeModule, TreeNode, InputTextModule, ButtonModule, DialogModule, Message} from 'primeng/primeng';
import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {SelectItem, AutoCompleteModule, ConfirmationService} from 'primeng/primeng';
import { BusinessUnit } from '../../Models/BusinessUnit';
import { } from 'rxjs';
import { Profile } from '../../Models/profile.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
declare var google: any;

@Component({
    templateUrl: './TeamHierarchy.html'
})

export class TeamHierarchyComponent implements OnInit {
currentUserName: string | null;
currentUserId:any;
rootEmployee: any;
TeamMembersByIDData:any;
chart: any;
data: any;
expandedNodes: Set<number> = new Set();

nodeChildrenMap: Map<number, number[]> = new Map(); // New
isDefaultHierarchy: boolean = true; // for toggle
currentUser: any = null;
currentLead: any = null;
currentReportees: any[] = [];
isLoading: boolean = false;
selectedProfile: any = null;
suggestions: any[] = [];

// Add dropdown options and value for the dropdown next to "Simplified View"
dropdownOptions: any[] = [];
selectedDropdownValue: any = null;

profiles: Profile[] = [];

searchText: string = '';
filteredProfiles: Profile[] = [];
selectedProfileId: number | null = null;

// Add this property to fix the error
selectedUserId: number | null = null;


constructor(
    private seedDataService: SeedDataService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private profileDataService: ProfileDataService,
    private route: ActivatedRoute
  ) {}

ngOnInit() { 
    // get userId from route params
    this.route.params.subscribe(params => {
      let userId = params['userId'];
      if (!userId) {
        // fallback to logged-in user if no param
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.currentUserName = currentUser.fullname || 'Unknown';
        userId = currentUser.UserId || 'Unknown';
      /**
       * Expands or collapses a node in the org chart.
       */
     
      }
      this.currentUserId = userId;
      // Always show user-centric org chart by default (toggle ON)
      this.isDefaultHierarchy = true;
      // Ensure Google Charts is loaded before drawing
      google.charts.load('current', { packages: ['orgchart'] });
      google.charts.setOnLoadCallback(() => {
        if (this.isDefaultHierarchy) {
          this.drawUserCentricOrgChart(this.currentUserId);
        } else {
          this.loadHierarchyForUser(this.currentUserId);
        }
      });
    });
    // Load dropdown options on init
   this.loadProfilesForDropdown()
}
 toggleExpandCollapse(userId: number) {
        if (!this.expandedNodes) {
          this.expandedNodes = new Set<number>();
        }
        if (this.expandedNodes.has(userId)) {
          // Collapse: remove children rows and mark as collapsed
          this.removeChildrenRows(userId);
          this.expandedNodes.delete(userId);
          // Redraw chart to reflect collapsed state
          if (this.chart && this.data) {
            this.chart.draw(this.data, { orientation: 'vertical', allowHtml: true });
          }
        } else {
          // Expand: fetch and add children rows, mark as expanded
          this.expandedNodes.add(userId);
          this.expandNode(userId);
        }
      }
      
getHtmlNode(member: any): string {
  // Helper to get initials if no image
  function getInitials(name: string) {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  const hasImage = !!member.imagePath;
  const initials = getInitials(member.name);

  // Prepare values
  const name = member.name || '';
  const leadName = member.LeadName || member.leadName || '';
  const designation = member.designation || 'Not Available';
  const location = member.workLocation || 'Not Available';
  const email = member.email || 'Not Available';
  const phone = member.mobile || 'Not Available';
  const managerName = member.managerName || member.managerName || '';
  const childCount = member.childCount;

  // HTML for icons with tooltip and copy
  const iconStyle = `
    display:inline-block;
    margin: 0 6px;
    cursor:${Number(member.childCount) > 0 ? 'pointer' : 'default'};
    color:#EE2E4A;
    font-size:16px;
    vertical-align:middle;
    position:relative;
  `;

  // Arrow logic (replace with accordion icon)
  const showArrow = Number(childCount) > 0;
  // Always use Number for Set lookup to avoid type mismatch
  const userIdNum = Number(member.userId);
  const isExpanded = this.expandedNodes && this.expandedNodes.has(userIdNum);
  let arrowHtml = '';
  if (!this.isDefaultHierarchy) { 
    debugger;
    // Accordion icon: down for collapsed, up for expanded
    arrowHtml = showArrow
      ? `
        <span 
          style="margin-left:8px; color:#b0b0b0; font-size:22px; font-weight:bold; cursor:pointer; pointer-events:auto; display:inline-flex; align-items:center;"
          onclick="event.stopPropagation(); window.handleExpandCollapse && window.handleExpandCollapse(${userIdNum});"
          title="View Hierarchy"
          id="expand-collapse-span-${userIdNum}"
        >
          <i class="fa ${isExpanded ? 'fa-angle-up' : 'fa-angle-down'}" id="expand-collapse-icon-${userIdNum}" aria-hidden="true"></i>
        </span>
      `
      : '';
    // Always assign the expand/collapse function globally to ensure latest context
    if (typeof window !== 'undefined') {
      (window as any).handleExpandCollapse = (userId: number) => {
        this.toggleExpandCollapse(Number(userId));
      };
    }
  }
  else {
    // User-centric: only arrow click triggers showUserCentricHierarchy, node is not clickable
    arrowHtml = showArrow
      ? `
        <span 
          style="margin-left:8px; color:#b0b0b0; font-size:22px; font-weight:bold; cursor:pointer; pointer-events:auto;"
          onclick="event.stopPropagation(); window.showUserCentricHierarchy && window.showUserCentricHierarchy(${member.userId});"
          title="View Hierarchy"
          id="expand-collapse-span-${member.userId}"
        >
          <i class="fa fa-angle-down" id="expand-collapse-icon-${member.userId}"></i>
        </span>
      `
      : '';
    // Make the showUserCentricHierarchy function available globally
    if (typeof window !== 'undefined' && !(window as any).showUserCentricHierarchy) {
      (window as any).showUserCentricHierarchy = (userId: number) => {
        this.showUserCentricHierarchy(userId);
      };
    }
  }

  return `
    <div style="
      padding: 8px;
      background:white;
      height: 100px;
      /* cursor pointer only for name/profile/arrow, not for whole card */
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      box-shadow: 0 2px 8px rgba(0,0,0,0.07);
      align-items: center;
      width:auto;
    ">
      <div style="width: 80px; display: flex; flex-direction: column; align-items: center; justify-content: flex-start;">
        <div style="width: 54px; height: 54px; margin-bottom: 6px; background: #f5f5f5; border-radius: 50%; border:2px solid red; display: flex; align-items: center; justify-content: center; cursor:pointer;"
          tabindex="-1"
          draggable="false"
          aria-label=""
          title=""
           onclick="${Number(childCount) > 0
            ? (!this.isDefaultHierarchy
                ? `window.handleExpandCollapse && window.handleExpandCollapse(${member.userId});`
                : `window.showUserCentricHierarchy && window.showUserCentricHierarchy(${member.userId});`)
            : ''}"
        >
          ${
            hasImage
              ? `<img alt="Profile" src="${member.imagePath}" width="54" height="54" style="width:54px;height:54px;object-fit:cover;border-radius:50%;cursor:pointer;" onerror="this.src='/Images/avtar1.png'" tabindex="-1" draggable="false" aria-label="" title="" />`
              : `<span style="display:inline-block;width:54px;height:54px;line-height:54px;text-align:center;background:#EE2E4A;color:#fff;font-size:20px;font-weight:bold;border-radius:50%;border:2px solid red;cursor:pointer;" tabindex="-1" aria-label="" title="">${initials}</span>`
          }
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
          <span 
            style="${iconStyle}; margin-left:0; margin-right:0px; pointer-events:auto; position:relative;${email && email !== 'Not Available' ? 'cursor:pointer;' : 'cursor:not-allowed;opacity:0.5;'}; font-size:16px;"
            onclick="if('${email}' && '${email}' !== 'Not Available'){event.stopPropagation(); navigator.clipboard.writeText('${email}').then(()=>{let msg=document.createElement('span');msg.innerText='Copied!';msg.style.position='absolute';msg.style.left='50%';msg.style.top='-22px';msg.style.transform='translateX(-50%)';msg.style.background='#23272f';msg.style.color='#fff';msg.style.fontSize='12px';msg.style.padding='2px 8px';msg.style.borderRadius='4px';msg.style.zIndex='9999';this.appendChild(msg);setTimeout(()=>{if(msg.parentNode){msg.parentNode.removeChild(msg);}},900);});}"
            title="${email && email !== 'Not Available' ? 'Copy to clipboard!' : 'No email available'}"
          >
            <i class="fa fa-envelope" style="font-size:16px;height:20px;width:34px;line-height:20px;"></i>
          </span>
          <span 
            style="${iconStyle}; margin-right:2px; margin-left:-4px; pointer-events:auto; position:relative;${phone && phone !== 'Not Available' ? 'cursor:pointer;' : 'cursor:not-allowed;opacity:0.5;'}"
            onclick="if('${phone}' && '${phone}' !== 'Not Available'){event.stopPropagation(); navigator.clipboard.writeText('${phone}').then(()=>{let msg=document.createElement('span');msg.innerText='Copied!';msg.style.position='absolute';msg.style.left='50%';msg.style.top='-22px';msg.style.transform='translateX(-50%)';msg.style.background='#23272f';msg.style.color='#fff';msg.style.fontSize='12px';msg.style.padding='2px 8px';msg.style.borderRadius='4px';msg.style.zIndex='9999';this.appendChild(msg);setTimeout(()=>{if(msg.parentNode){msg.parentNode.removeChild(msg);}},900);});}"
            title="${phone && phone !== 'Not Available' ? 'Copy to clipboard!' : 'No phone available'}"
          >
            <i class="fa fa-mobile" style="font-size:20px;height:20px;width:28px;line-height:20px;"></i>
          </span>
        </div>
      </div>
      <div style="flex:1; display: flex; flex-direction: column; justify-content: center; min-width:0;">
        <div 
          style="
            font-weight: 600;
            font-size: 14px;
            color: #23272f;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 0px;
            text-align: left;
            position: relative;
            cursor: pointer;
          "
          ${leadName && leadName.trim() && leadName !== 'Not Available' ? `title="Reports To: ${leadName}"` : ''}
         onclick="${Number(childCount) > 0
            ? (!this.isDefaultHierarchy
                ? `window.handleExpandCollapse && window.handleExpandCollapse(${member.userId});`
                : `window.showUserCentricHierarchy && window.showUserCentricHierarchy(${member.userId});`)
            : ''}"
          >
          ${name}
        </div>
        <div style="
          font-size: 13px;
          color: #000;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 0px;
          text-align: left;
          pointer-events: none;
          cursor: default;
        "
        >
          <i class="fa fa-map-marker" style="color:#EE2E4A; margin-right:4px;"></i>${location}
          
        </div>
        ${
          ((!managerName || managerName === 'undefined' || managerName.trim() === '') &&
            (!leadName || leadName === 'undefined' || leadName.trim() === ''))
            ? ''
          : (managerName && managerName === leadName && managerName !== 'undefined' && managerName.trim() !== '')
            ? `<div style="
                font-size: 13px;
                color: #000;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 0px;
                text-align: left;
                pointer-events: none;
                cursor: default;
              ">
                <span>Manager/Lead:</span> ${managerName}
              </div>`
          : (managerName && managerName !== leadName && managerName !== 'undefined' && managerName.trim() !== '')
            ? `<div style="
                font-size: 13px;
                color: #000;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 0px;
                text-align: left;
                pointer-events: none;
                cursor: default;
              ">
                <span>Manager:</span> ${managerName}
              </div>
              ${
                leadName && leadName !== 'undefined' && leadName.trim() !== ''
                  ? `<div style="
                      font-size: 13px;
                      color: #000;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin-bottom: 0px;
                      text-align: left;
                      pointer-events: none;
                      cursor: default;
                    ">
                      <span>Lead:</span> ${leadName}
                    </div>`
                  : ''
              }`
            : (leadName && leadName !== 'undefined' && leadName.trim() !== '')
              ? `<div style="
                  font-size: 13px;
                  color: #000;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 0px;
                  text-align: left;
                  pointer-events: none;
                  cursor: default;
                ">
                  <span>Lead:</span> ${leadName}
                </div>`
              : ''
        }
        <div style="
          font-size: 13px;
          color: #000;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          pointer-events: none;
          cursor: default;
        "
        >
          <i class="fa fa-briefcase" style="color:#EE2E4A; margin-right:4px;"></i>${designation}
        </div>
      </div>
      ${arrowHtml}
    </div>
  `;
}
GetTeamMembersByID(Id){
  debugger;
    this.isLoading = true;
    this.profileDataService.GetTeamMembersByID(Id).subscribe((profiles: Profile[]) => {
        console.log('TeamMembers:', profiles);
        this.rootEmployee = profiles;
        this.isLoading = false;
    }, error => {
        this.isLoading = false;
    });
}

// Call this from the template when the toggle changes
onToggleHierarchy() {
  // Always reset to logged-in user when toggling
  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  this.currentUserName = currentUser.fullname || 'Unknown';
  this.currentUserId = currentUser.UserId || 'Unknown';

  // Clear search text and selection when toggling
  this.searchText = '';
  this.selectedProfileId = null;
  this.filteredProfiles = [];

  if (this.isDefaultHierarchy) {
    // Draw user-centric org chart (centered on logged-in user)
    this.drawUserCentricOrgChart(this.currentUserId);
    this.selectedUserId = this.currentUserId;
  } else {
    // Draw default org chart for logged-in user
    this.loadHierarchyForUser(this.currentUserId);
    this.selectedUserId = this.currentUserId;
  }
}

loadHierarchyForUser(userId: any) {
  debugger;
  this.isLoading = true;
  this.profileDataService.GetTeamMembersByID(userId).subscribe((profiles: Profile[]) => {
    this.isLoading = false;
    this.rootEmployee = profiles;
    google.charts.load('current', { packages: ['orgchart'] });
    google.charts.setOnLoadCallback(() => {
      this.drawChart();
    });
  });
}

drawChart() {
  debugger;

  // Use selected user ID if available, else use logged-in user
  const targetUserId = this.selectedUserId || this.currentUserId;

  this.data = new google.visualization.DataTable();
  this.data.addColumn('string', 'Name');
  this.data.addColumn('string', 'Manager');
  this.data.addColumn('string', 'Tooltip');

  const user = this.rootEmployee.find(e => +e.userId === +targetUserId);
  if (!user) {
    console.error('Target user not found!');
    return;
  }

  const lead = this.rootEmployee.find(e => +e.id === +user.functionalLead);
  const root = lead || user;

  const rows: any[] = [];

  // Always add top/root node
  rows.push([
    { v: root.userId.toString(), f: this.getHtmlNode(root) },
    null,
    root.name
  ]);

  // Add current user under lead (if not same as root)
  if (user.userId !== root.userId) {
    rows.push([
      { v: user.userId.toString(), f: this.getHtmlNode(user) },
      root.userId.toString(),
      user.name
    ]);
  }

  // Add direct children
  const children = this.rootEmployee.filter(e => +e.functionalLead === +user.id);
  children.forEach(child => {
    rows.push([
      { v: child.userId.toString(), f: this.getHtmlNode(child) },
      user.userId.toString(),
      child.name
    ]);
  });

  this.data.addRows(rows);
  this.chart = new google.visualization.OrgChart(document.getElementById('orgchart'));
  this.chart.draw(this.data, { orientation: 'vertical', allowHtml: true });

  if (!this.expandedNodes) this.expandedNodes = new Set<number>();
  this.expandedNodes.add(targetUserId);
}
private expandNode(userId: number) {
    this.isLoading = true;

  this.profileDataService.GetTeamMembersByID(userId).subscribe((profiles: Profile[]) => {
      this.isLoading = false;

    const clickedUser = profiles.find(p => +p.userId === +userId);
    if (!clickedUser) return;

    const children = profiles.filter(p => +p.functionalLead === +clickedUser.id);
    const childRows: any[] = [];

    children.forEach(child => {
      childRows.push([
        { v: child.userId.toString(), f: this.getHtmlNode(child) },
        clickedUser.userId.toString(),
        child.name
      ]);
    });

    this.data.addRows(childRows);
    this.chart.draw(this.data, { orientation: 'vertical', allowHtml: true });
  });
}

// Recursive remove children and descendants of parentUserId from this.data
private removeChildrenRows(parentUserId: number) {
  const toRemove = new Set<string>();
  const queue = [parentUserId.toString()];

  // Do not include parentUserId itself — only its descendants
  queue.shift(); // Remove the first item (parent itself)

  // Collect all descendants recursively
  const toProcess = [parentUserId.toString()];
  while (toProcess.length > 0) {
    const current = toProcess.shift();
    for (let i = 0; i < this.data.getNumberOfRows(); i++) {
      const manager = this.data.getValue(i, 1);
      const userId = this.data.getValue(i, 0);
      if (manager === current && !toRemove.has(userId)) {
        toRemove.add(userId);
        toProcess.push(userId);
      }
    }
  }

  // Rebuild only rows not in toRemove
  const newRows: any[] = [];
  for (let i = 0; i < this.data.getNumberOfRows(); i++) {
    const userId = this.data.getValue(i, 0);
    if (!toRemove.has(userId)) {
      const manager = this.data.getValue(i, 1);
      const tooltip = this.data.getValue(i, 2);
      const formatted = this.data.getFormattedValue(i, 0);
      newRows.push([{ v: userId, f: formatted }, manager, tooltip]);
    }
  }

  this.data = new google.visualization.DataTable();
  this.data.addColumn('string', 'Name');
  this.data.addColumn('string', 'Manager');
  this.data.addColumn('string', 'Tooltip');
  this.data.addRows(newRows);
}

// Draw org chart centered on a user: lead (if any), user, reportees
drawUserCentricOrgChart(userId: any) {
   this.isLoading = true;
   this.profileDataService.GetTeamMembersByID(userId).subscribe((profiles: Profile[]) => {
        this.isLoading = false;
        const user = profiles.find(e => +e.userId === +userId);
        if (!user) return;

        const lead = profiles.find(e => +e.id === +user.functionalLead);
        const reportees = profiles.filter(e => +e.functionalLead === +user.id);

        const data = new google.visualization.DataTable();
        data.addColumn('string', 'Name');
        data.addColumn('string', 'Manager');
        data.addColumn('string', 'Tooltip');

        // Add lead if exists
        if (lead) {
          data.addRow([
            { v: lead.userId.toString(), f: this.getHtmlNode(lead) },
            null,
            lead.name
          ]);
          // Add user under lead
          data.addRow([
            { v: user.userId.toString(), f: this.getHtmlNode(user) },
            lead.userId.toString(),
            user.name
          ]);
        } else {
          // User is root
          data.addRow([
            { v: user.userId.toString(), f: this.getHtmlNode(user) },
            null,
            user.name
          ]);
        }

        // Add reportees under user
        reportees.forEach(r => {
          data.addRow([
            { v: r.userId.toString(), f: this.getHtmlNode(r) },
            user.userId.toString(),
            r.name
          ]);
        });

        const chart = new google.visualization.OrgChart(document.getElementById('orgchart'));
        chart.draw(data, { orientation: 'vertical', allowHtml: true });

        this.focusNodeInChart(userId, profiles, 'orgchart');
        // Removed node click event for user-centric hierarchy; arrow click handled in getHtmlNode
   });
}

// New method: showUserCentricHierarchy
showUserCentricHierarchy(userId: any) {
  this.currentUserId = userId;
  this.drawUserCentricOrgChart(userId);
}
// Utility function to focus a node by userId and profiles array
private focusNodeInChart(userId: any, profiles: Profile[], chartDivId: string) {
  setTimeout(() => {
    try {
      const orgchartDiv = document.getElementById(chartDivId);
      if (orgchartDiv) {
        const user = profiles.find(e => +e.userId === +userId);
        if (!user) return;
        const nodeEls = orgchartDiv.querySelectorAll('td.google-visualization-orgchart-node');
        for (let i = 0; i < nodeEls.length; i++) {
          const el = nodeEls[i] as HTMLElement;
          if (el.innerHTML.indexOf(user.name) !== -1) {
            const parent = orgchartDiv;
            const scrollLeft = el.offsetLeft - (parent.clientWidth / 2) + (el.clientWidth / 2);
            const scrollTop = el.offsetTop - (parent.clientHeight / 2) + (el.clientHeight / 2);
            parent.scrollLeft = scrollLeft;
            parent.scrollTop = scrollTop;
            break;
          }
        }
      }
    } catch (e) {}
  }, 0);
}

GetAllTeamMembersByName(){
  debugger;
    this.isLoading = true;
    this.profileDataService.GetAllTeamMembersByName().subscribe((profiles: Profile[]) => {
        console.log('TeamMembers:', profiles);
     
        this.isLoading = false;
    }, error => {
        this.isLoading = false;
    });
}

// Use this to load and bind data to dropdown
loadProfilesForDropdown() {

  this.isLoading = true;
  this.profileDataService.GetAllTeamMembersByName().subscribe(
    (profiles: Profile[]) => {
      this.profiles = profiles || [];
      this.isLoading = false;
      console.log(this.profiles , "Profile new met")
    },
    error => {
      this.profiles = [];
      this.isLoading = false;
    }
  );
}

filterProfiles() {

  const query = this.searchText.toLowerCase();
  this.filteredProfiles = this.profiles.filter(profile =>
    profile.nameWithEmail.toLowerCase().includes(query)
  );
}

selectProfile(profile: Profile) {
  this.selectedProfileId = profile.userId;
  this.filteredProfiles = [];
  this.onDropdownChange(profile.userId);
  this.searchText = ''; // Clear search box after opening hierarchy
}

onDropdownChange(userId: number) {
  
  const selectedProfile = this.profiles.find(p => p.userId === userId);
  if (selectedProfile) {
    console.log(selectedProfile,"mkmlll")
   if (this.isDefaultHierarchy) {
    // Draw user-centric org chart (centered on logged-in user)
    this.drawUserCentricOrgChart(selectedProfile.userId);
    this.selectedUserId=selectedProfile.userId
  } else {
    
    // Draw default org chart for logged-in user
    this.loadHierarchyForUser(selectedProfile.userId);
    this.selectedUserId=selectedProfile.userId
  }
  } else {
    console.warn('Selected profile not found!');
  }
  
}
clearSearch() {
  this.searchText = '';
  this.filteredProfiles = [];
}

}


// WEBPACK FOOTER //
// ./src/app/Components/TeamHierarchy/TeamHierarchy.ts